import React from 'react';

export const Profile = ({route}) => {
    return (
        <div style={{display: route == 6 ? 'block': 'none'}}>
            
        </div>
    )
};

export default Profile;